import api from '../services/api';
import { querystring } from '../utils/resposta';

// Pedido de interesse em ser APOIADOR do projeto. Nasce no app, com os dados do
// próprio perfil da pessoa (nome, estado e foto); o administrador aprova ou recusa
// aqui no painel. Mesmo desenho do pedido de perfil Profissional.
//
// Só o lado do administrador existe no site: quem pede é o app.
const SolicitacaoApoiador = {
  findAll: async function (page = 1, limit = 10, status = '') {
    return await api.get(`/solicitacoes-apoiador/all/${page}/${limit}${querystring({ status })}`)
      .then(response => response)
      .catch(error => error);
  },

  contagem: async function () {
    return await api.get('/solicitacoes-apoiador/contagem')
      .then(response => response)
      .catch(error => error);
  },

  // Aprovar cria o apoiador na mesma operação do backend (uma transação).
  aprovar: async function (id, resposta) {
    return await api.patch(`/solicitacoes-apoiador/${id}/aprovar`, resposta ? { resposta } : {})
      .then(response => response)
      .catch(error => error);
  },

  recusar: async function (id, resposta) {
    return await api.patch(`/solicitacoes-apoiador/${id}/recusar`, { resposta })
      .then(response => response)
      .catch(error => error);
  },
  // Desabilitar tira o apoio do site e do app sem apagar nada; habilitar volta.
  // So para pedido aprovado (o backend responde 409 nos demais).
  desabilitar: async function (id) {
    return await api.patch(`/solicitacoes-apoiador/${id}/desabilitar`)
      .then(response => response)
      .catch(error => error);
  },

  habilitar: async function (id) {
    return await api.patch(`/solicitacoes-apoiador/${id}/habilitar`)
      .then(response => response)
      .catch(error => error);
  },
};

export default SolicitacaoApoiador;
